module.exports = __webpack_public_path__ + "fonts/Barlow-Medium.d4afdc1.ttf";